module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/blueseal_d_gift12-b136da319b144ed5eeb43deb01946716.jpg";